import { Typography } from '@mui/material'
import type { FC } from 'react'
import GridContainer from '../../../shared/components/GridContainer'
import RespondToMailOffer from '../../../shared/components/RespondToMailOffer'
import { TrustPilotVariant, TrustPilotWidget } from '../../../shared/components/TrustPilotWidget'
import MLHomePageHeroImage from './MLHomePageHeroImage'
import { colors } from '../../../shared/theme/colors'
import buttons from './buttons'

const Header: FC = () => (
  <section
    id="landing-page-header"
    data-testid="landing-page-header"
    className="min-h-[55vh] justify-center flex flex-col py-16 md:py-24 bg-gradient-to-b from-white to-ink-200"
  >
    <GridContainer>
      <div className="md:flex flex-row items-center col-span-full md:col-span-full">
        <div className="flex flex-col col-span-full gap-4 md:w-[50%]">
          <div className="flex flex-col gap-4">
            <Typography variant="h1">Credit that moves you forward</Typography>
            <div className="md:hidden">
              <MLHomePageHeroImage />
            </div>
            <div className="md:max-w-[85%]">
              <Typography variant="p1">
                Join over 3 million members who count on a Mission Lane Visa
                <sup>®</sup> Credit Card every day.{' '}
                <Typography
                  variant="p1"
                  component="span"
                  sx={{ color: colors.Ink[900], fontWeight: 600 }}
                >
                  See if you&apos;ll be approved with no impact to your credit score.
                </Typography>
              </Typography>
            </div>
          </div>
          <div className="flex flex-col md:flex-row gap-4 md:gap-2 items-stretch md:items-center md:mb-2">
            {buttons.hero}
            <RespondToMailOffer id="respond-to-mail-offer-button-header" />
          </div>
          <div className="md:max-w-[420px]">
            <TrustPilotWidget variant={TrustPilotVariant.MicroCombo} />
          </div>
        </div>
        <div className="hidden md:flex md:w-[43%]">
          <MLHomePageHeroImage />
        </div>
      </div>
    </GridContainer>
  </section>
)

export default Header
